import React from "react";
import { useForm } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { fetchGroup } from "../common/slices/group";
import { selectActive } from "../common/slices/location";
import { BlackButton, ButtonBase, LightButton } from "./Buttons";
import FormSelectGroup from "./FormSelectGroup";
import FormSelectScopeOfWork from "./FormSelectScopeOfWork";
import FormTextInput from "./FormTextInput";
import Modal from "./Modal";
import Row from "./Row";
import { H1, P, Pmb } from "./Typography";

const marshall = (input, locationId) => ({
    ...input,
    hours: "",
    locationId,
})

const ModalGroupAddTimeEntry = ({ group, onClose }) => {
    const dispatch = useDispatch();
    const locationId = useSelector(selectActive);
    const formValues = marshall(group, locationId);

    const {
        control,
        formState: { errors, isSubmitting, isValid },
        handleSubmit
    } = useForm({
        values: { ...formValues },
    })

    const formProps = { control, errors, locationId }

    const onSave = async ({ groupId, hours, scopeId }) => {
        const group = await dispatch(fetchGroup(groupId.value, locationId));
        onClose({
            group,
            hours,
            scopeId
        });
    }

    return (
        <Modal show size="60%" zindex='1200'>
            <Row>
                <H1>Add From Group</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>

            <Pmb>Group Details</Pmb>
            <P>Use the form below to create a time entry for a group of users.</P>
            <Row>
                <FormSelectGroup {...formProps} name="groupId" label="Group" placeholder="Select a group" rules={{ required: true }} />
                <FormSelectScopeOfWork {...formProps} name="scopeId" label="Scope of Work" rules={{ required: true }} />
                <FormTextInput {...formProps} name="hours" label="Hours" placeholder="Enter hours" rules={{ required: true, min: 0, max: 24, pattern: /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/i }} />
            </Row>

            <Row>
                <BlackButton onClick={handleSubmit(onSave)} disabled={isSubmitting || !isValid}>Save</BlackButton>
                <LightButton onClick={onClose} disabled={isSubmitting}>Cancel</LightButton>
            </Row>
        </Modal>
    );
};

export default ModalGroupAddTimeEntry;
